

const packageJson = require('./package.json');


// const APP_VERSION = '$Revision$ $Date$';
// const APP_BUILD = '';

export function getAppVersion() {
    return `${ packageJson.version }`;
}

// /web/0.3
export function getAppVersionMM() {
    return "0.3";
}
